/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { LargeFeedFilter } from "cms/shared/feeds/large";
import React, { useState, useMemo } from "react";
import { FollowedInfoCard } from "mydnv/components/followed-infocard/followed-infocard";
import { SubscribeButton } from "mydnv/components/subscribe-button";
import { ShareButton } from "cms/shared/share-button";
import { WhenSignedIn } from "mydnv/components/sign-in/sign_in_out_util";
import { BookmarkButton } from "mydnv/components/bookmark-button";
import { Config } from "config";

const Advisories = () => {
    const type = "model.notice"; //todo: change to advisories

    // determines what message / style to show in 'info card' after follow / subscribe / bookmark buttotn clicked
    const [actionType, setActionType] = useState(null);
    const [subTopic, setSubtopic] = useState("");
    const wpGuid = Config.MyDNV.webpageGuidsList.advisories;

    const wpObj = useMemo(() => {
        return {
            guid: wpGuid,
            title: "Advisories",
            published_date: null,
            updated_date: null,
        };
    }, [wpGuid]);

    return (
        <main>
            <WhenSignedIn>
                {actionType !== null && (
                    <FollowedInfoCard type={actionType} handleDismiss={setActionType} subTopic={subTopic} />
                )}
            </WhenSignedIn>
            <h1 style={{ marginTop: "16px" }}>Advisories</h1>
            {/* Share bar */}
            <div className='nav-container'>
                <div className='mod-date-container no-date'>
                    {/* <LastModified className="modified-time-nav" model={model} /> */}
                </div>
                <div className='buttons-container no-date advisories'>
                    <SubscribeButton
                        subscriptionTopic='Advisories'
                        setActionType={setActionType}
                        webpageGuid={wpGuid}
                        className='subscribe-btn-nav'
                        setSubtopic={setSubtopic}
                    ></SubscribeButton>
                    <BookmarkButton setActionType={setActionType} wpObj={wpObj}></BookmarkButton>

                    <ShareButton className='share-btn-nav' />
                </div>
            </div>
            <div className='last-updated-rule'></div>
            <LargeFeedFilter type={type} enableBar={true} />
        </main>
    );
};

export { Advisories };
